/*
 * � 2020 Microsoft. All rights reserved.
 */

define('version',['text!version.json'], function(v) {
    var _v = JSON.parse(v);


    return {

        name: function () {
            return _v.name;
        },

        id: function () {
            return _v.id;
        },

        version: function () {
            return _v.string + "_" +  _v.date + "_" + _v.time;
        },

        shortVersion: function() {
            return _v.string;
        }

    }
});
